import { AppFlow } from '@lib/web-shared';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import VerifyPolicyInfoForm from '../components/VerifyPolicyInfoForm';
import { Pages } from '../shared/pages';
import { useGlobalState } from '../shared/state';
import { ErrorType, IGetPolicyPaymentInfoResponse } from '../shared/types';
import { UtagHelper } from '../utils/utagHelper';
import LogCannon from '@ace-clublabs/log-cannon';

const VerifyPolicyInfoPage: React.FC = () => {
  const [policyPaymentInfo] = useGlobalState('policyPaymentInfo');
  const [policyMetaData] = useGlobalState('policyMetaData');
  const [isMobileApp] = useGlobalState('isMobileApp');
  const [appFlow] = useGlobalState('appFlow');
  const [clubTag] = useGlobalState('clubTag');
  const [tagging, setIsTagging] = useState(true);
  const [, setAlreadyPaidOption] = useGlobalState('alreadyPaidOption');
  const { minimumDue, fullBalance, allowAutoPay, autoPayFeatureIsOffline } =
    policyPaymentInfo as IGetPolicyPaymentInfoResponse;
  let navigate = useNavigate();

  const handleNext = (val: any) => {
    const { yesNoToggle } = val;
    if (yesNoToggle === 'Y') {
      if (appFlow === AppFlow.AUTOPAY && autoPayFeatureIsOffline)
        navigate(Pages.SorryPage, { state: { errorType: ErrorType.TEMPORARILY_UNAVAILABLE_ERROR } });
      else if (minimumDue) {
        navigate(Pages.PaymentSelection);
      } else if (fullBalance && !allowAutoPay) {
        navigate(Pages.AlreadyPaid);
      } else {
        if (appFlow !== AppFlow.AUTOPAY) {
          if (fullBalance && !minimumDue) {
            navigate(Pages.AlreadyPaid);
          } else {
            if (allowAutoPay) {
              navigate(Pages.AutoPay);
            } else {
              LogCannon.blast('Unknown error in verify policy info page after clicking Next button', {
                yesNoToggle,
                minimumDue,
                fullBalance,
                allowAutoPay,
                appFlow,
              });
            }
          }
        } else {
          navigate(Pages.AutoPay);
        }
      }
    } else {
      navigate(Pages.SubmitInsurance);
    }
  };

  const handleBack = () => {
    navigate(-1);
  };

  useEffect(() => {
    setAlreadyPaidOption(undefined);
    const ins_policy = policyMetaData.prefix;
    const tags = { ...UtagHelper.loadCommonTags(appFlow), page: UtagHelper.getPages(appFlow).verifyPolicyInfoPage };

    UtagHelper.tag({
      ...tags,
      club: clubTag,
      state: policyMetaData.state,
      ins_policy,
    });

    setIsTagging(false);
  }, []);

  const { lastName } = policyPaymentInfo || {};

  if (tagging) {
    return <></>;
  }

  return (
    <VerifyPolicyInfoForm
      lastName={lastName?.toUpperCase()!}
      handleBack={handleBack}
      handleNext={handleNext}
      isMobileApp={isMobileApp}
    />
  );
};

export default VerifyPolicyInfoPage;
